module.exports = __webpack_public_path__ + "static/laura_paez-87c00fef6229349fbe00fb94cf950668.jpg";